/**
 * `job.description` is recruiter-authored HTML, not markdown — rendering it via
 * `dangerouslySetInnerHTML` without stripping script-capable content would let a compromised or
 * malicious recruiter account run script in every talent's browser who opens the job. Shared
 * between job-detail-page.tsx and job-search-page.tsx's preview pane so a future fix lands once,
 * not in whichever copy someone remembers to update.
 */
export function sanitizeJobDescription(html: string): string {
  if (typeof window === 'undefined') return html
  const document = new DOMParser().parseFromString(html, 'text/html')
  document.querySelectorAll('script, style, iframe, object, embed').forEach((element) => element.remove())
  document.body.querySelectorAll('*').forEach((element) => {
    Array.from(element.attributes).forEach((attribute) => {
      const name = attribute.name.toLowerCase()
      const value = attribute.value.trim().toLowerCase()
      if (name.startsWith('on') || ((name === 'href' || name === 'src') && value.startsWith('javascript:'))) {
        element.removeAttribute(attribute.name)
      }
    })
  })
  return document.body.innerHTML
}
